import { documentTrackingInfo } from './fleetwoodProductCategory';
import toLower from './toLower';

// Adds `data-track-*` attributes to Fleetwood Technical Resources file-download
// links so they can be picked up by analytics. Returns a cleanup function that
// disconnects the observer, suitable for use as a useEffect teardown.
const trackFleetwoodTechnicalResourceDownloads = (container, { buildType } = {}) => {
  if (!container) return undefined;

  const isFleetwood = buildType === 'Product::Fleetwood';
  const section = container.closest('[data-am-region]');
  const isInTechResources = section?.dataset?.amRegion === 'Technical Resources';
  if (!isFleetwood || !isInTechResources) return undefined;

  let cancelled = false;

  const applyAttrs = link => {
    const docEl = link.closest('.document');
    if (!docEl) return;
    const fileName = toLower(docEl.querySelector('.document-text')?.textContent?.trim());
    const docType = toLower(link.closest('[data-tab-heading]')?.dataset?.tabHeading);
    link.setAttribute('data-track', 'file-download');
    if (fileName) link.setAttribute('data-track-file-name', fileName);
    if (docType) link.setAttribute('data-track-doc-type', docType);

    documentTrackingInfo(docEl).then(({ fileType, productType } = {}) => {
      if (cancelled) return;
      const lowerFileType = toLower(fileType);
      const lowerProductType = toLower(productType);
      if (lowerFileType) link.setAttribute('data-track-file-type', lowerFileType);
      if (lowerProductType) link.setAttribute('data-track-product-type', lowerProductType);
    });
  };

  container.querySelectorAll('.document a').forEach(applyAttrs);

  const observer = new MutationObserver(mutations => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        const links = node.tagName === 'A' ? [node] : Array.from(node.querySelectorAll('a'));
        links.forEach(link => {
          if (link.closest('.document')) applyAttrs(link);
        });
      });
    });
  });
  observer.observe(container, { childList: true, subtree: true });
  return () => {
    cancelled = true;
    observer.disconnect();
  };
};

export default trackFleetwoodTechnicalResourceDownloads;
